/** @jsx jsx */
import React from 'react';
import { css, keyframes, jsx } from '@emotion/react';
var fadeIn = keyframes({
  to: {
    opacity: 1
  }
});
var fadeInStyles = css({
  animation: "".concat(fadeIn, " 500ms ease forwards"),
  opacity: 0
});
export var FadeIn = function FadeIn(props) {
  return jsx("div", {
    css: fadeInStyles,
    className: props.className
  }, props.children);
};